import colors from '@theme/colors';
import React from 'react';
import { ViewStyle, Modal, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styles from './styles';

interface MyModalProps {
  isVisible: boolean;
  onPress?: () => void;
  children?: React.ReactNode;
  containerStyle?: ViewStyle;
  hasBackdrop?: boolean;
  customBackdrop?: React.ReactNode;
  backdropOpacity?: number;
  onModalHide?: () => void;
  testID?: string;
  statusBarTranslucent?: boolean;
}

const MyModal: React.FC<MyModalProps> = ({
  isVisible = false,
  onPress = () => {},
  children = null,
  containerStyle = {},
  hasBackdrop = true,
  customBackdrop,
  backdropOpacity = 0.7,
  onModalHide = () => {},
  testID = `modalBackdrop`,
  ...props
}) => {
  // Remove ref and useEffect - control with index prop

  const handleClose = () => {
    onPress();
    onModalHide();
  };

  return (
    <Modal
      visible={isVisible}
      animationType="none"
      presentationStyle="overFullScreen"
      transparent
      onRequestClose={handleClose}
      {...props}>
      <TouchableOpacity
        testID={testID}
        style={{
          flex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          justifyContent: 'flex-end',
        }}
        activeOpacity={1}
        onPress={handleClose}>
        <TouchableOpacity
          style={[
            { backgroundColor: colors.neutral.cotton, borderTopLeftRadius: 20, borderTopRightRadius: 20 },
            props.outerContainerStyle || styles.heightCommon,
          ]}
          activeOpacity={1}
          onPress={e => e.stopPropagation()}>
          <SafeAreaView edges={['bottom']} style={styles.modalParent(containerStyle)}>
            {children}
          </SafeAreaView>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

export default MyModal;
